<style src="./MirrorForm.scss" lang="scss"></style>
<template>
  <section class="mirror-form">
    <ul class="container">
      <li
        class="categories"
        v-for="(category, categoryIdx) in categories"
        :key="categoryIdx">
        <span class="title">{{ category.categoryTitle }}</span>

        <ul class="requirements">
          <li
            class="requirement"
            v-for="(requirement, requirementIdx) in category.requirement"
            :key="requirementIdx">

            <component
              class="component"
              :is="defineComponentType(requirement)"
              :title="requirement.title"
              v-model="requirement.inputValue" />
            
            <ul class="sub-requirements">
              <li
                class="sub-requirement"
                v-for="(subRequirement, subRequirementIdx) in requirement.requirementDetail"
                :key="subRequirementIdx">

                <component
                  :is="defineComponentType(subRequirement)"
                  :title="subRequirement.title"
                  v-model="subRequirement.inputValue" />
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <div
      class="commands">
      <button
        class="btn btn-success"
        @click="saveBidMirror">
        Salvar
      </button>
    </div>
  </section>
</template>

<script>
import * as FormFields from './components'

export default {
  name: 'BidMIrror',
  components: {
    ...FormFields
  },
  props: {
    eventId: null
  },
  data () {
    return {
      categories: [],
      bidMirror: []
    }
  },
  async mounted () {
    await this.GetBidMirrorByEvent()
    await this.listAllRequirements()
  },
  methods: {
    async listAllRequirements () {
      const { list } = await this.$store.dispatch('BidMirror/LIST_BID_MIRRORS', {
        mergeWith: this.bidMirror
      })
      this.categories = list
    },
    defineComponentType ({ inputType }) {
      switch (inputType) {
        case 'ANCHOR':
          return 'FieldAnchor'
        case 'TEXT':
          return 'FieldText'
        case 'CHECK':
          return 'FieldCheck'
        case 'DATE':
          return 'FieldDate'
        default:
          return 'FieldCheck'
      }
    },
    async saveBidMirror () {
      try {
        const form = {
          requirements: this.categories,
          eventId: this.eventId
        }
        await this.$store.dispatch('BidMirror/SAVE_BID_MIRROR', form)
        this.$toasted.success('Salvo com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível salvar')
      }
    },
    async GetBidMirrorByEvent () {
      const { bidMirror } = await this.$store.dispatch('BidMirror/GET_BID_MIRROR_BY_EVENT', {
        eventId: this.eventId
      })

      this.bidMirror = bidMirror
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/bid-mirror/mirror-form/MirrorForm.vue